import { PUSH_TROUBLESHOOTING_SLUG } from '@gitcenter/shared';
import zhPush from './markdown/zh/push-troubleshooting.md?raw';
import enPush from './markdown/en/push-troubleshooting.md?raw';
import type { DocsLangCode } from '@gitcenter/shared';

const REGISTRY: Record<string, Record<DocsLangCode, string>> = {
    [PUSH_TROUBLESHOOTING_SLUG]: { zh: zhPush, en: enPush },
};

export const DOC_SLUGS = Object.keys(REGISTRY);

export function isDocSlug(slug: string): boolean {
    return slug in REGISTRY;
}

export function getDocMarkdown(lang: DocsLangCode, slug: string): string | null {
    const entry = REGISTRY[slug];
    if (!entry) return null;
    return entry[lang];
}
